var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { MenuItem, Typography } from "@mui/material";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { MuiStack } from "../../../components";
import { LOCAL_STORAGE_KEYS, StatusEnum } from "../../../constants";
import { useAppSelector } from "../../../store/hooks";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { partDetailsByProductIdAPICall } from "../../purchaseOrder/services/apiCalls";
import PartInfoTooltip from "../../spareParts/purchaseRequistion/components/partInfoTooltip";
import { procurementPriorityListAPICall, searchByProductCodeAndNameAPICall } from "../../spareParts/purchaseRequistion/services/apiCall";
import { PurchaseRequisitionKeys } from "../../spareParts/purchaseRequistion/services/entity";
var PartDetailsPR = function (props) {
    var _crud$PurchaseRequisi, _getLocalStorageItem, _value$PurchaseProcur;
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get("mode");
    var onChange = props.onChange, value = props.value, error = props.error;
    var crud = useAppSelector(function (state) { return state.crud; });
    useEffect(function () {
        procurementPriorityListAPICall({});
    }, []);
    var isDisabled = mode !== "add" ? ![StatusEnum.Cancelled].includes((_crud$PurchaseRequisi = crud[PurchaseRequisitionKeys.Get]) === null || _crud$PurchaseRequisi === void 0 || (_crud$PurchaseRequisi = _crud$PurchaseRequisi.data) === null || _crud$PurchaseRequisi === void 0 || (_crud$PurchaseRequisi = _crud$PurchaseRequisi.Status) === null || _crud$PurchaseRequisi === void 0 ? void 0 : _crud$PurchaseRequisi.Name) : true;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var getPartListByPagination = function (params) { return searchByProductCodeAndNameAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread({
            skip: 0,
            take: 10,
            SupplierId: value === null || value === void 0 ? void 0 : value.SupplierId
        }, params.request)
    })); };
    var columns = [{
            type: "searchSelect",
            field: "Product",
            headerName: "Part name & code",
            editable: true,
            flex: 1,
            headerAlign: "left",
            minWidth: 250,
            getListData: getPartListByPagination,
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                Product: value,
                ProductName: value === null || value === void 0 ? void 0 : value.Name,
                ProductCode: value === null || value === void 0 ? void 0 : value.SkuCode,
                ChildId: value === null || value === void 0 ? void 0 : value.id
            }); },
            renderCell: function (params) {
                var _params$row, _params$row2, _params$row3, _params$row4;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#1B1D21"
                    }
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.ProductName ? "".concat(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.ProductName) : ""), /*#__PURE__*/ React.createElement(Typography, {
                    style: {
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#6A7682"
                    }
                }, params !== null && params !== void 0 && (_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.ProductCode ? "#".concat(params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ProductCode) : ""));
            },
            apiKey: PurchaseRequisitionKeys.PartListByName,
            placeholder: "Search Part by name",
            moreButtonText: "Search More...",
            getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.Name) + " | " + (option === null || option === void 0 ? void 0 : option.SkuCode); },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            renderOption: function (props, option) {
                return /*#__PURE__*/ React.createElement(MenuItem, props, /*#__PURE__*/ React.createElement(MuiStack, {
                    width: "200px"
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        overflow: "hidden",
                        whiteSpace: "wrap",
                        textOverflow: "ellipsis"
                    }
                }, option === null || option === void 0 ? void 0 : option.Name)), /*#__PURE__*/ React.createElement(MuiStack, {
                    width: "100px",
                    borderLeft: "1px solid ".concat(systemColor.grey),
                    paddingX: 2
                }, /*#__PURE__*/ React.createElement(Typography, null, option === null || option === void 0 ? void 0 : option.SkuCode)));
            }
        }, {
            type: "string",
            field: "UnitOfMeasurementName",
            headerName: "UOM",
            flex: 1,
            headerAlign: "left",
            placeholder: "Select UOM",
            minWidth: 150
        }, {
            type: "string",
            field: "MRP",
            headerName: "MRP",
            flex: 1,
            headerAlign: "left",
            minWidth: 150
        }, {
            type: "string",
            field: "PurchaseRate",
            headerName: "PurchaseRate",
            flex: 1,
            headerAlign: "left",
            minWidth: 150
        }, {
            type: "number",
            field: "TotalAvailableQuantity",
            headerName: "Available Quantity",
            editable: false,
            flex: 1,
            headerAlign: "left",
            minWidth: 150
        }, {
            type: "number",
            field: "StorageLocation",
            headerName: "Storage location",
            editable: true,
            placeholder: "Enter",
            flex: 1,
            headerAlign: "left",
            minWidth: 150
        }, {
            type: "number",
            field: "DiscountName",
            headerName: "Requested transfer qauntity",
            editable: false,
            flex: 1,
            headerAlign: "left",
            minWidth: 150
        }, {
            type: "string",
            field: "Remarks",
            headerName: "Remarks",
            editable: true,
            flex: 1,
            placeholder: "Enter remarks",
            headerAlign: "left",
            minWidth: 250
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        onChange: onChange,
        disableAddRow: !isDisabled,
        dataGridHeader: "Part details",
        dataGridProps: {
            rowSelection: isDisabled,
            isCellEditable: function (params) {
                return isDisabled;
            },
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            processRowUpdate: function (newRow, oldRow) { return __awaiter(void 0, void 0, void 0, function () {
                var _newRow$Product, _oldRow$Product, row, _newRow$Product2, _response$data, _response$data2, _response$data3, _response$data4, _response$data5, _response$data6, _response$data7, _response$data8, _response$data9, _response$data10, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            row = newRow;
                            if (!((newRow === null || newRow === void 0 || (_newRow$Product = newRow.Product) === null || _newRow$Product === void 0 ? void 0 : _newRow$Product.id) !== (oldRow === null || oldRow === void 0 || (_oldRow$Product = oldRow.Product) === null || _oldRow$Product === void 0 ? void 0 : _oldRow$Product.id))) return [3 /*break*/, 2];
                            return [4 /*yield*/, partDetailsByProductIdAPICall({
                                    request: {
                                        OrganizationId: UserOrganization,
                                        ProductId: newRow === null || newRow === void 0 || (_newRow$Product2 = newRow.Product) === null || _newRow$Product2 === void 0 ? void 0 : _newRow$Product2.id
                                    }
                                })];
                        case 1:
                            response = _a.sent();
                            row = _objectSpread(_objectSpread({}, newRow), {}, {
                                HsnId: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.HsnCodeId,
                                HsnCode: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.HsnCode,
                                UnitOfMeasurementId: response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.UnitOfMeasurementId,
                                UnitOfMeasurementName: response === null || response === void 0 || (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.UnitOfMeasurementName,
                                TotalAvailableQuantity: response === null || response === void 0 || (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.AvailableQuantity,
                                TaxId: response === null || response === void 0 || (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.TaxId,
                                TaxName: response === null || response === void 0 || (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.TaxValue,
                                Rate: response === null || response === void 0 || (_response$data8 = response.data) === null || _response$data8 === void 0 || (_response$data8 = _response$data8.PurchaseBasePrice) === null || _response$data8 === void 0 ? void 0 : _response$data8.Price,
                                ChargeId: response === null || response === void 0 || (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.ChargeId,
                                DiscountId: response === null || response === void 0 || (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.DiscountId
                            });
                            _a.label = 2;
                        case 2: return [2 /*return*/, row];
                    }
                });
            }); }
        },
        rows: (_value$PurchaseProcur = value === null || value === void 0 ? void 0 : value.PurchaseProcurementDetails) !== null && _value$PurchaseProcur !== void 0 ? _value$PurchaseProcur : [{
                id: 1
            }],
        validationModel: {
            Quantity: function (value, row) {
                if (value < 1)
                    return "Quantity must not go below 0.";
            },
            Product: function (productValue, row, rowsLookup) {
                var _rowsLookup$values;
                if (rowsLookup !== null && rowsLookup !== void 0 && (_rowsLookup$values = rowsLookup.values()) !== null && _rowsLookup$values !== void 0 && (_rowsLookup$values = _rowsLookup$values.toArray()) !== null && _rowsLookup$values !== void 0 && _rowsLookup$values.some(function (it) { return it.ChildId === (productValue === null || productValue === void 0 ? void 0 : productValue.id); }))
                    return "Part already requested.";
            }
        },
        error: error === null || error === void 0 ? void 0 : error["PurchaseProcurementDetails"],
        cellInfoModel: {
            Product: function () { return value !== null && value !== void 0 && value.Product ? /*#__PURE__*/ React.createElement(PartInfoTooltip, null) : undefined; }
        }
    });
};
export default PartDetailsPR;
